


















import {defineComponent, computed, PropType} from "@vue/composition-api"
import {useActions, useGetters} from "vuex-composition-helpers"
import {ILabels} from "@/apps/StudentExchangeProgressColumnWidget/models/config-viewmodel"
import ProgressBar from "@/apps/StudentExchangeProgressColumnWidget/components/ProgressBar.vue"
import {useProgressExchangeBus} from "@/shared/composables/progressExchangeBus"


export default defineComponent({
    name: "StudentExchangeProgressColumnWidget",
    components: {ProgressBar},
    props: {
        labels: {
            type: Object as PropType<ILabels>,
            required: true
        },
        progressLabels: {
            type: [] as PropType<[]>,
            required: true
        }
    },
    setup: (props: { labels: ILabels, progressLabels: [] }) => {
        const {setLabels, setProgressLabels} = useActions([
            'setLabels',
            'setProgressLabels'
        ])
        setLabels(props.labels)
        setProgressLabels(props.progressLabels)

        const {getLabels, getProgressLabels} = useGetters([
            'getLabels',
            'getProgressLabels'
        ])

        const completed = computed(() => useProgressExchangeBus().progress)
        const progressValue = computed(() => {
                let value = ((completed.value.length / getProgressLabels.value.length) * 100)
                return Number(value.toFixed(0))
            }
        )

        return {
            completed,
            getProgressLabels,
            progressValue,
            getLabels
        }
    }
})
